export default __webpack_public_path__ + "static/media/group-580.f6cac006.png";